import React from "react";

function AiIcon() {
	return (
		<svg width='200' height='130' viewBox='0 0 200 130' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<g filter='url(#filter0_dddddd_22_28235)'>
				<rect x='80' y='10' width='40' height='40' rx='12' fill='url(#paint0_linear_22_28235)' />
				<g clipPath='url(#clip0_22_28235)'>
					<path
						d='M109.97 27.8756C110.233 27.0873 110.324 26.2522 110.237 25.4259C110.151 24.5997 109.889 23.8015 109.469 23.0847C108.846 22.0005 107.895 21.1421 106.753 20.6333C105.611 20.1246 104.337 19.9918 103.115 20.2542C102.564 19.6328 101.886 19.1364 101.127 18.7981C100.368 18.4599 99.5462 18.2876 98.7155 18.2928C97.4657 18.2898 96.2473 18.6838 95.2358 19.4179C94.2244 20.152 93.4722 21.1883 93.0877 22.3775C92.2735 22.5442 91.5044 22.8828 90.8317 23.3708C90.159 23.8588 89.5984 24.4848 89.1872 25.2071C88.5598 26.2883 88.2919 27.5408 88.4223 28.7841C88.5528 30.0274 89.0747 31.1971 89.9129 32.1245C89.6504 32.9128 89.5594 33.7479 89.6458 34.5742C89.7323 35.4004 89.9942 36.1986 90.4141 36.9154C91.0367 37.9996 91.9876 38.8579 93.1296 39.3667C94.2715 39.8754 95.5457 40.0082 96.768 39.7459C97.3194 40.3673 97.9971 40.8637 98.7558 41.202C99.5146 41.5402 100.337 41.7125 101.167 41.7072C102.418 41.7105 103.637 41.3164 104.649 40.5818C105.661 39.8472 106.413 38.8102 106.797 37.6203C107.611 37.4536 108.38 37.115 109.053 36.627C109.726 36.139 110.286 35.5129 110.698 34.7907C111.324 33.7096 111.591 32.4573 111.461 31.2146C111.33 29.9718 110.808 28.8026 109.97 27.8756ZM101.169 40.1766C100.143 40.178 99.1487 39.8186 98.3605 39.1611C98.396 39.1417 98.4584 39.1075 98.499 39.0826L103.161 36.3897C103.278 36.3231 103.375 36.2266 103.443 36.11C103.51 35.9934 103.545 35.861 103.544 35.7264V29.1537L105.515 30.2916C105.525 30.2967 105.534 30.3043 105.541 30.3137C105.547 30.3232 105.552 30.3341 105.553 30.3455V35.7887C105.552 36.9513 105.089 38.0659 104.268 38.8883C103.446 39.7108 102.332 40.1741 101.169 40.1766ZM91.7417 36.1501C91.2276 35.2618 91.0423 34.2209 91.2182 33.2097C91.2529 33.2305 91.3133 33.2674 91.3567 33.2924L96.0188 35.9853C96.135 36.0532 96.2672 36.089 96.4018 36.089C96.5363 36.089 96.6684 36.0532 96.7846 35.9853L102.477 32.6988V34.9744C102.477 34.986 102.475 34.9977 102.47 35.0082C102.465 35.0187 102.458 35.0279 102.448 35.0349L97.7355 37.756C96.7275 38.3366 95.5302 38.4935 94.4065 38.1925C93.2828 37.8914 92.3245 37.1569 91.7417 36.1501ZM90.5152 25.9724C91.0271 25.0829 91.8357 24.4018 92.7992 24.0485C92.7992 24.0886 92.7969 24.1597 92.7969 24.2091V29.595C92.7961 29.7295 92.8311 29.8618 92.8984 29.9783C92.9656 30.0948 93.0627 30.1913 93.1796 30.2578L98.8715 33.544L96.901 34.6817C96.8912 34.6882 96.8801 34.692 96.8685 34.6931C96.8569 34.6941 96.8452 34.6923 96.8345 34.6878L92.1211 31.9644C91.1148 31.3816 90.3807 30.4236 90.0796 29.3003C89.7786 28.1771 89.9352 26.9803 90.5152 25.9724ZM106.705 29.7399L101.013 26.4534L102.984 25.316C102.994 25.3096 103.005 25.3057 103.016 25.3046C103.028 25.3036 103.04 25.3055 103.05 25.31L107.764 28.0311C108.486 28.4482 109.074 29.0624 109.46 29.8018C109.845 30.5412 110.012 31.3751 109.941 32.2059C109.87 33.0368 109.564 33.8302 109.058 34.4933C108.552 35.1563 107.868 35.6615 107.086 35.9498C107.086 35.9091 107.086 35.8381 107.086 35.7887V30.4028C107.087 30.2685 107.052 30.1363 106.985 30.0198C106.918 29.9033 106.822 29.8068 106.705 29.7399ZM108.667 26.788C108.632 26.7668 108.571 26.7303 108.528 26.7054L103.866 24.0125C103.75 23.9447 103.618 23.9089 103.483 23.9089C103.349 23.9089 103.216 23.9447 103.1 24.0125L97.4082 27.299V25.0234C97.4076 25.0117 97.4098 25.0001 97.4147 24.9896C97.4196 24.9791 97.4271 24.9699 97.4364 24.9629L102.149 22.2441C102.871 21.8278 103.697 21.6257 104.53 21.6614C105.362 21.6971 106.168 21.9693 106.851 22.4459C107.535 22.9226 108.069 23.5841 108.39 24.3531C108.712 25.122 108.808 25.9666 108.667 26.788ZM96.3369 30.8441L94.3659 29.7062C94.3555 29.7011 94.3466 29.6935 94.3399 29.6841C94.3332 29.6746 94.329 29.6637 94.3276 29.6522V24.2091C94.3281 23.3754 94.5661 22.5592 95.0137 21.8558C95.4613 21.1525 96.1 20.5912 96.855 20.2377C97.61 19.8842 98.4501 19.753 99.2769 19.8596C100.104 19.9661 100.883 20.306 101.524 20.8395C101.488 20.8588 101.426 20.893 101.385 20.9179L96.7232 23.6109C96.6062 23.6774 96.5091 23.7738 96.4417 23.8903C96.3744 24.0068 96.3394 24.1392 96.3401 24.2737L96.3369 30.8441ZM97.4073 28.5361L99.9424 27.0719L102.477 28.5352V31.4626L99.9424 32.9259L97.4073 31.4626V28.5361Z'
						fill='white'
					/>
				</g>
			</g>
			<defs>
				<filter
					id='filter0_dddddd_22_28235'
					x='0'
					y='-70'
					width='200'
					height='200'
					filterUnits='userSpaceOnUse'
					colorInterpolationFilters='sRGB'
				>
					<feFlood floodOpacity='0' result='BackgroundImageFix' />
					<feColorMatrix
						in='SourceAlpha'
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
						result='hardAlpha'
					/>
					<feOffset dy='2.76726' />
					<feGaussianBlur stdDeviation='1.1069' />
					<feColorMatrix
						type='matrix'
						values='0 0 0 0 0.360784 0 0 0 0 0.52549 0 0 0 0 0.756863 0 0 0 0.0196802 0'
					/>
					<feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_22_28235' />
					<feColorMatrix
						in='SourceAlpha'
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
						result='hardAlpha'
					/>
					<feOffset dy='6.6501' />
					<feGaussianBlur stdDeviation='2.66004' />
					<feColorMatrix
						type='matrix'
						values='0 0 0 0 0.360784 0 0 0 0 0.52549 0 0 0 0 0.756863 0 0 0 0.0282725 0'
					/>
					<feBlend mode='normal' in2='effect1_dropShadow_22_28235' result='effect2_dropShadow_22_28235' />
					<feColorMatrix
						in='SourceAlpha'
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
						result='hardAlpha'
					/>
					<feOffset dy='12.5216' />
					<feGaussianBlur stdDeviation='5.00862' />
					<feColorMatrix
						type='matrix'
						values='0 0 0 0 0.360784 0 0 0 0 0.52549 0 0 0 0 0.756863 0 0 0 0.035 0'
					/>
					<feBlend mode='normal' in2='effect2_dropShadow_22_28235' result='effect3_dropShadow_22_28235' />
					<feColorMatrix
						in='SourceAlpha'
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
						result='hardAlpha'
					/>
					<feOffset dy='22.3363' />
					<feGaussianBlur stdDeviation='8.93452' />
					<feColorMatrix
						type='matrix'
						values='0 0 0 0 0.360784 0 0 0 0 0.52549 0 0 0 0 0.756863 0 0 0 0.0417275 0'
					/>
					<feBlend mode='normal' in2='effect3_dropShadow_22_28235' result='effect4_dropShadow_22_28235' />
					<feColorMatrix
						in='SourceAlpha'
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
						result='hardAlpha'
					/>
					<feOffset dy='41.7776' />
					<feGaussianBlur stdDeviation='16.711' />
					<feColorMatrix
						type='matrix'
						values='0 0 0 0 0.360784 0 0 0 0 0.52549 0 0 0 0 0.756863 0 0 0 0.0503198 0'
					/>
					<feBlend mode='normal' in2='effect4_dropShadow_22_28235' result='effect5_dropShadow_22_28235' />
					<feColorMatrix
						in='SourceAlpha'
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
						result='hardAlpha'
					/>
					<feOffset />
					<feGaussianBlur stdDeviation='40' />
					<feColorMatrix
						type='matrix'
						values='0 0 0 0 0.360784 0 0 0 0 0.52549 0 0 0 0 0.756863 0 0 0 0.07 0'
					/>
					<feBlend mode='normal' in2='effect5_dropShadow_22_28235' result='effect6_dropShadow_22_28235' />
					<feBlend mode='normal' in='SourceGraphic' in2='effect6_dropShadow_22_28235' result='shape' />
				</filter>
				<linearGradient
					id='paint0_linear_22_28235'
					x1='80'
					y1='50.1456'
					x2='120'
					y2='50.1456'
					gradientUnits='userSpaceOnUse'
				>
					<stop stopColor='#5C86C1' />
					<stop offset='1' stopColor='#81CAB2' />
				</linearGradient>
				<clipPath id='clip0_22_28235'>
					<rect width='24' height='24' fill='white' transform='translate(88 18)' />
				</clipPath>
			</defs>
		</svg>
	);
}

export default AiIcon;
